/* eslint-disable jsx-a11y/anchor-is-valid */
import {Col, Row, Stack} from 'react-bootstrap'
import {StepProps} from '../IAppModels'
import deleteButton from '../../../../images/deleteButton.svg'
import {useEffect, useState, useRef} from 'react'

const Step2 = ({
  data,
  updateData,
  hasError,
  setHasError,
  isDisabled,
  style,
  validation,
  callBack,
}: StepProps) => {
  const [addBrandList, setAddBrandList] = useState([
    {brandName: '', brandEmailId: '', emailError: '', brandError: '', disable: 'false'},
  ])
  const scrollEndRef = useRef<null | HTMLDivElement>(null)
  const inputStyle = {}
  useEffect(() => {
    setAddBrandList(data.brandInfo)
  }, [data])

  useEffect(() => {
    setAddBrandList(addBrandList)
  }, [addBrandList])
  // Handling Input Change
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>, index: any) => {
    const {name, value} = e.target
    const list = [...addBrandList] as any
    list[index][name] = value
    setAddBrandList(list)
    updateData({brandInfo: list})
  }

  // Handling delete
  const handleDelete = (index: any, data1: any) => {
    const list = [...addBrandList] as any
    let brands
    if (data1.id) {
      brands = data.brandInfo.map((admin: any) => {
        if (admin.id === data1.id) {
          admin.isDelete = true
        }
        return admin
      })
    }
    list.splice(index, 1)
    setAddBrandList(list)
  }

  // Handling Add
  const handleAdd = () => {
    let dataInfo: any
    dataInfo = data.brandInfo.filter((admin: any) => {
      if (admin.isDelete && !admin.flag) {
        admin.flag = 1
        return admin
      }
    })
    // the addbrandList has records of already created
    let list = [...dataInfo] as any
    list = [...list, ...addBrandList]
    list.push({
      brandName: '',
      brandEmailId: '',
      emailError: '',
      disable: 'false',
    })
    setAddBrandList(list)
  }

  const handleBlur = (e: any, index: any) => {
    const values = [...addBrandList]
    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(addBrandList[index].brandEmailId)) {
      values[index]['emailError'] = 'Invalid email address'
      setAddBrandList(values)
      // setHasError(true)
      callBack(false, addBrandList)
    }else if(addBrandList[index].brandEmailId === data.clientInfo.clientAdmin.clientEmail){
      values[index]['emailError'] = 'Email cannot be same as client'
      setAddBrandList(values)
      callBack(false, addBrandList)
    } else if ( values.some((user, index, array) =>array.findIndex((u) => u.brandEmailId === user.brandEmailId) !== index)){
      values[index]['emailError'] = 'Duplicate email found'
      setAddBrandList(values)
      callBack(false, addBrandList)
    } else
    {
      values[index]['emailError'] = ''
      setAddBrandList(values)
      callBack(true, addBrandList)
    }
  }

  const brandHandleBlur = (e: any, index: any) => {
    const values = [...addBrandList]
    if (!/^[0-9a-zA-Z \b]+$/.test(addBrandList[index].brandName)) {
      values[index]['brandError'] = 'Special characters are not allowed'
      setAddBrandList(values)
      callBack(false, addBrandList)
    } else if (addBrandList[index].brandName.length > 20) {
      values[index]['brandError'] = "System admin name shouldn't exceed 20 characters"
      setAddBrandList(values)
      callBack(false, addBrandList)
    } else {
      values[index]['brandError'] = ''
      setAddBrandList(values)
      callBack(true, addBrandList)
    }
  }

  return (
    <div data-kt-stepper-element='content'>
      <div className='w-100' style={{height: '430px', overflowX: 'hidden', overflowY: 'auto'}}>
        {/*begin::Form Group */}
        <div className='form'>
          <div className='fv-row'>
            {/* begin::Label */}
            <Stack direction='horizontal'>
              <div>
                <label className='d-flex align-items-center fs-5 fw-semibold mb-4'>
                  <span className='fw-bold fs-3'>System Admin List</span>
                </label>
              </div>
              <div className='ms-auto'>
                <button
                  type='button'
                  className='btn btn-light-primary me-3 fs-6 fw-500 mb-4'
                  style={{
                    width: '145px',
                    height: '38px',
                    padding: '3px',
                  }}
                  data-kt-menu-trigger='click'
                  data-kt-menu-placement='bottom-end'
                  onMouseDown={() => handleAdd()}
                  onClick={() => {
                    scrollEndRef.current?.scrollIntoView({behavior: 'smooth'})
                  }}
                >
                  Add System Admin
                </button>
              </div>
            </Stack>
            {/* end::Label */}
            {/*begin:Option */}
            <Row className='mb-5 mt-5'>
              <Col sm={5}>
                <span className='fs-6'>System Admin Name</span>
              </Col>
              <Col style={{width: '143px'}}>
                <span className='fs-6'>System Admin Email ID</span>
              </Col>
            </Row>
            <div
              style={{
                height: '240px',
                overflowX: 'hidden',
                overflowY: 'auto',
                paddingRight: '10px',
                gap: '20px',
              }}
              className='d-flex flex-column'
            >
              {addBrandList &&
                addBrandList.map((field: any, i) => {
                  if (field && !field.isDelete) {
                    return (
                      <>
                        <Row key={i} className='d-flex align-items-start'>
                          <Col sm={5} md={5} className='mr-12px '>
                            <input
                              type='text'
                              className='form-control form-control-lg form-control-solid'
                              name='brandName'
                              placeholder='Enter system admin name'
                              value={field.brandName}
                              style={inputStyle}
                              // eslint-disable-next-line no-sequences
                              onChange={(e) => (handleChange(e, i), brandHandleBlur(e, i))}
                              // onBlur={(e) => brandHandleBlur(e, i)}
                            />

                            <div
                              className='fv-plugins-message-container'
                              style={{position: style.positionStyle}}
                            >
                              {field.brandName && field.brandError ? (
                                <div
                                  data-field='appname'
                                  data-validator='notEmpty'
                                  className='fv-help-block'
                                >
                                  {field.brandError}
                                </div>
                              ) : (
                                <div
                                  data-field='appname'
                                  data-validator='notEmpty'
                                  className='fv-help-block'
                                  style={{visibility: 'hidden'}}
                                >
                                  {field.brandError}
                                </div>
                              )}
                            </div>
                          </Col>
                          <Col sm={5} md={5} className='ml-12px '>
                            <input
                              type='text'
                              className='form-control form-control-lg form-control-solid'
                              name='brandEmailId'
                              placeholder='Enter email id'
                              // disabled={field.disable == 'false' ? false : isDisabled}
                              value={field.brandEmailId.split('/')[0]}
                              style={{...inputStyle}}
                              onChange={(e) => (handleChange(e, i), handleBlur(e, i))}
                              // onBlur={(e)=>handleBlur(e,i)}
                            />

                            <div
                              className='fv-plugins-message-container'
                              style={{position: style.positionStyle}}
                            >
                              {field.brandEmailId && field.emailError ? (
                                <div
                                  data-field='appname'
                                  data-validator='notEmpty'
                                  className='fv-help-block'
                                >
                                  {field.emailError}
                                </div>
                              ) : (
                                <div
                                  data-field='appname'
                                  data-validator='notEmpty'
                                  className='fv-help-block'
                                  style={{visibility: 'hidden'}}
                                >
                                  {field.emailError}
                                </div>
                              )}
                            </div>
                          </Col>
                          <Col
                            sm={2}
                            md={2}
                            style={{
                              textAlign: 'center',
                              alignItems: 'center',
                            }}
                          >
                            <img
                              src={deleteButton}
                              alt='delete'
                              onClick={() => handleDelete(i, field)}
                              className='pointer'
                            />
                          </Col>
                        </Row>
                      </>
                    )
                  }
                })}
              <div style={{float: 'left', clear: 'both'}} ref={scrollEndRef} />
            </div>
          </div>
        </div>
        {/*end::Form Group */}
      </div>
    </div>
  )
}

export {Step2}
